var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutocompleteSelect',{attrs:{"props":_vm.props},on:{"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }